<template>
  <TabMenu :model="navItems" />
</template>
<script>
import TabMenu from 'primevue/tabmenu';
import { RouteNames } from '@/data/routes';

export default {
  components: {
    TabMenu,
  },
  methods: {
    isRouteActive(route) {
      return this.$route.name === route;
    },
  },
  computed: {
    navItems() {
      return [
        {
          label: this.$t('account.pages.subPageRepayments.upcoming'),
          to: { name: RouteNames.PAYMENTS.UPCOMING },
          disabled: this.isRouteActive(RouteNames.PAYMENTS.UPCOMING),
        },
        {
          label: this.$t('account.pages.subPageRepayments.history'),
          to: { name: RouteNames.PAYMENTS.INDEX },
          disabled: this.isRouteActive(RouteNames.PAYMENTS.INDEX),
        },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.p-tabmenuitem.p-highlight.p-disabled) {
  opacity: 1;
}
</style>
